/**
 * Builds the standard Bearer Authorization header for ffh-backend calls.
 * Use at call sites to remove the per-request template-literal repetition
 * without giving up the SSR-safety of passing tokens explicitly.
 */
export const authHeader = (accessToken: string) => ({
  Authorization: `Bearer ${accessToken}`
});
